import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 29286 33255"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#1c1b17;stroke-width:481.962}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970277762688">
        <path
          d="M2163 7473c1060 0 1922 861 1922 1922s-861 1921-1922 1921-1922-860-1922-1921 861-1922 1922-1922zM2163 14706c1060 0 1922 860 1922 1922 0 1061-861 1921-1922 1921s-1922-860-1922-1921c0-1062 861-1922 1922-1922zM8403 7473c1061 0 1921 861 1921 1922s-860 1921-1921 1921-1921-860-1921-1921 860-1922 1921-1922zM8403 14706c1061 0 1921 860 1921 1922 0 1061-860 1921-1921 1921s-1921-860-1921-1921c0-1062 860-1922 1921-1922zM8403 21938c1061 0 1921 861 1921 1922s-860 1922-1921 1922-1921-861-1921-1922 860-1922 1921-1922zM14643 14706c1061 0 1922 860 1922 1922 0 1061-861 1921-1922 1921s-1922-860-1922-1921c1-1062 861-1922 1922-1922zM14643 21938c1061 0 1922 861 1922 1922s-861 1922-1922 1922-1922-861-1922-1922c1-1061 861-1922 1922-1922zM14643 29171c1061 0 1922 861 1922 1922s-861 1921-1922 1921-1922-860-1922-1921c1-1061 861-1922 1922-1922zM20884 7473c1061 0 1922 861 1922 1922s-860 1921-1922 1921c-1061 0-1922-860-1922-1921s860-1922 1922-1922zM20884 14706c1061 0 1922 860 1922 1922 0 1061-860 1921-1922 1921-1061 0-1922-860-1922-1921 0-1062 860-1922 1922-1922zM20884 21938c1061 0 1922 861 1922 1922s-860 1922-1922 1922c-1061 0-1922-861-1922-1922s860-1922 1922-1922zM27124 7473c1061 0 1921 861 1921 1922s-860 1921-1921 1921-1921-860-1921-1921 860-1922 1921-1922zM27124 14706c1061 0 1921 860 1921 1922 0 1061-860 1921-1921 1921s-1921-860-1921-1921c0-1062 860-1922 1921-1922zM2163 241c1060 0 1922 860 1922 1921s-861 1922-1922 1922S241 3224 241 2162c0-1061 861-1921 1922-1921zM27124 241c1061 0 1921 860 1921 1921s-860 1922-1921 1922-1921-860-1921-1922c0-1061 860-1921 1921-1921z"
          className="fill stroke1s"
          style={{
            strokeWidth: 481.962,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
